<!-- 选择角色时候提示信息 -->
<template>
  <div>
    <zlr-modal v-model="modelShow">
      <div class="prompt">
        <h1>You haven’t been matched with mentees yet</h1>
        <div class="prompt-con">
          However, if you'd like to be matched with mentees sonner, please email us at <span>mentors@zlrvaleon.com</span> and we can check if there is room to organize an online sharing session with you. It is possible that the attendees in the sharing session will choose you as their mentor once they sign with us. Also, the sharing session is the beginning for us to cooperate in other aspects besides mentoring.
        </div>
        <div class="prompt-btn">
          <Button type="primary"
                  class="btn" v-clipboard:copy="copyEmail" v-clipboard:success="onCopy" v-clipboard:error="onError" >Copy email</Button>
          <Button type="default"
                  class="btn" @click="modelShow = false">Close</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// componnets
import ZlrModal from '_c/modal/modal'
export default {
  name: '',
  components: {
    ZlrModal
  },
  data () {
    return {
      modelShow: false,
      copyEmail: 'mentors@zlrvaleon.com'
    }
  },
  computed: {},
  mounted () { },
  methods: {
    show () {
      this.modelShow = true
    },
    onCopy () {
      this.$zlr_message('Copy failed', 'success')
      this.modelShow = false
    },
    onError () {
      this.$zlr_message('Copy failed', 'error')
    }
  }
}
</script>
<style lang='less' scoped>
.prompt {
  width: 960px;
  text-align: center;
  padding: 12px 0;
  h1 {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
    font-weight: normal;
  }
  &-con {
    padding: 24px 0 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
    line-height: 24px;
    span{
      color: #6589dd;
    }
  }
  .btn {
    margin: 0 12px;
  }
}
</style>
